import { render, staticRenderFns } from "./AboutCytomineModal.vue?vue&type=template&id=01a04702&scoped=true"
import script from "./AboutCytomineModal.vue?vue&type=script&lang=js"
export * from "./AboutCytomineModal.vue?vue&type=script&lang=js"
import style0 from "./AboutCytomineModal.vue?vue&type=style&index=0&id=01a04702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a04702",
  null
  
)

export default component.exports